import {createContext, type PropsWithChildren, use, useMemo} from 'react'

export const IsLoadingContext = createContext<boolean | undefined>(undefined)

export function IsLoadingProvider({children, isLoading}: PropsWithChildren<{isLoading: boolean}>) {
  const value = useMemo(() => isLoading, [isLoading])

  return <IsLoadingContext value={value}>{children}</IsLoadingContext>
}

export function useIsLoading() {
  const context = use(IsLoadingContext)
  if (context === undefined) {
    throw new Error('useIsLoading must be used within a IsLoadingProvider')
  }
  return context
}
